import { createFileRoute } from '@tanstack/react-router'

// The list IS the section's level 0, rendered by the section itself; nothing is selected here.
export const Route = createFileRoute('/_app/admin/transitions/jobs/')({})
